import {
  Button,
  TextField,
  Theme,
  Typography,
  withStyles
} from '@material-ui/core'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { RequestHelperInput } from '../../types/graphql'
import { version } from '../../../package.json'
import { useMutation } from '@apollo/client'
import { REQUEST_HELP } from '../../graphql/queries'
import { useSnackbar } from 'notistack'

const SuccessButton = withStyles((theme: Theme) => ({
  root: {
    color: theme.palette.success.contrastText,
    width: '40%',
    margin: 15,
    padding: 15,
    backgroundColor: theme.palette.success.main,
    '&:hover': {
      backgroundColor: theme.palette.success.dark
    }
  }
}))(Button)

interface HelpFormProps {
  helperId: string | undefined
}

const HelpForm: React.FC<HelpFormProps> = ({ helperId }) => {
  const [data, setData] = useState({
    title: '',
    phone: '',
    message: ''
  })
  const { enqueueSnackbar } = useSnackbar()
  const [requestHelp, { loading }] = useMutation(REQUEST_HELP)

  const router = useHistory()

  const handleDataChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target

    setData(oldData => ({ ...oldData, [name]: value }))
  }

  const handleClick = () => {
    const { title, message, phone } = data
    const input: RequestHelperInput = {
      appVersion: version,
      link: window.location.href,
      userAgent: navigator.userAgent,
      title,
      message,
      phone,
      helperID: helperId
    }
    requestHelp({
      variables: {
        input
      }
    }).then(res => {
      enqueueSnackbar(res.data.requestHelp.message, {
        variant: 'success'
      })
      router.goBack()
    })
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100vh',
        justifyContent: 'center',
        backgroundColor: '#fff'
      }}
    >
      <Typography variant="h1" style={{ margin: 15 }}>
        Envie sua dúvida!
      </Typography>
      <h4 style={{ margin: '20px 0', width: '50%', textAlign: 'center' }}>
        Deixe seu contato para que possamos te ajudar e melhorar nosso serviços,
        deixe sua dúvida.
      </h4>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <TextField
          label="Título"
          name="title"
          value={data.title}
          type="text"
          onChange={handleDataChange}
          style={{ width: '40%', margin: 15 }}
        />
        {/* pattern="[0-9]{2}-[0-9]{5}-[0-9]{4}" */}
        <TextField
          label="Telefone"
          name="phone"
          value={data.phone}
          type="tel"
          style={{ width: '40%', margin: 15 }}
          onChange={handleDataChange}
        />
        <TextField
          label="Descreva sua dúvida e problema"
          type="text"
          multiline
          value={data.message}
          name="message"
          rows={4}
          onChange={handleDataChange}
          style={{ width: '40%', margin: 15 }}
        />
        <SuccessButton
          variant="contained"
          onClick={handleClick}
          disabled={loading}
        >
          {loading ? 'Enviando...' : 'Enviar dúvida'}
        </SuccessButton>
      </div>
    </div>
  )
}

export default HelpForm
